import { userService } from '../../helpers/authservice/user.service'
import router from '../../router/index'
import RoleService from '@/helpers/authservice/role.service'
import JwtService from '@/helpers/authservice/jwt.service'

const user = JSON.parse(localStorage.getItem('user'))
export const state = user ? { status: { loggeduser: true }, user } : { status: {}, user: null }

export const actions = {
  // Logs in the user.
  // eslint-disable-next-line no-unused-vars
  login({ dispatch, commit }, { email, password }) {
    commit('loginRequest', { email })
    return new Promise((resolve, reject) => {
      userService.login(email, password).then(
        (user) => {
          commit('loginSuccess', user)
          resolve(user)
          if (user.debe_cambiar_clave) {
            router.push('/change-password')
          } else {
            router.push('/')
          }
        },
        (error) => {
          commit('loginFailure', error)
          // dispatch('notification/error', error, { root: true });
          reject(error)
        }
      )
    })
  },
  loginGoogle({ dispatch, commit }, datos) {
    commit('loginRequest', datos)
    return new Promise((resolve, reject) => {
      userService.loginGoogle(datos).then(
        (user) => {
          commit('loginSuccess', user)
          resolve(user)
          router.push('/')
        },
        (error) => {
          commit('loginFailure', error)
          // dispatch('notification/error', error, { root: true });
          reject(error)
        }
      )
    })
  },
  restaurarContrasena({ dispatch, commit }, datos) {
    // commit('loginRequest', datos);
    return new Promise((resolve, reject) => {
      userService.restaurarContrasena(datos).then(
        (user) => {
          // commit('loginSuccess', user);
          resolve(user)
          router.push('/')
        },
        (error) => {
          // commit('loginFailure', error);
          // dispatch('notification/error', error, { root: true });
          reject(error)
        }
      )
    })
  },
  cambiarContrasena({ dispatch, commit }, datos) {
    // commit('loginRequest', datos);
    return new Promise((resolve, reject) => {
      userService.cambiarContrasena(datos).then(
        (user) => {
          // commit('loginSuccess', user);
          resolve(user)
          // router.push('/');
        },
        (error) => {
          // commit('loginFailure', error);
          // dispatch('notification/error', error, { root: true });
          reject(error)
        }
      )
    })
  },
  verifyAuth({ dispatch, commit }) {
    if (JwtService.getToken()) {
      return new Promise((resolve, reject) => {
        userService.verifyAuth().then(
          (user) => {
            // commit('loginSuccess', user);
            if (!user || user.status == 401) {
              console.log('test');
              dispatch('logout')
            // router.push('login');
            }
          },
          (error) => {
            dispatch('logout')
          }
        )
      })
    } else {
      dispatch('logout')
    }
  },
  // Logout the user
  logout({ commit }) {
    userService.logout()
    commit('logout')
  },
  // register the user
  registeruser({ dispatch, commit }, user) {
    commit('registerRequest', user)
    userService.register(user).then(
      (user) => {
        commit('registerSuccess', user)
        dispatch('notification/success', 'Registration successful', { root: true })
        router.push('/login')
      },
      (error) => {
        commit('registerFailure', error)
        dispatch('notification/error', error, { root: true })
      }
    )
  }
}

export const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess(state, user) {
    state.status = { loggeduser: true }
    state.user = user
    JwtService.saveToken(state.user.token)
    RoleService.saveRole(state.user.codigo_rol)
    // RoleService.saveRole(JSON.stringify(state.user.rol_modulo_permisos));
  },
  loginFailure(state) {
    state.status = {}
    state.user = null
  },
  logout(state) {
    state.status = {}
    state.user = null
    RoleService.destroyRole()
    JwtService.destroyToken()
  },
  registerRequest(state) {
    state.status = { registering: true }
  },
  registerSuccess(state) {
    state.status = {}
  },
  registerFailure(state) {
    state.status = {}
  }
}
